import { compose } from 'redux';
import { connect } from 'react-redux';
import selectors from '../../../../rootSelectors';
import RCT_AUDIO_INSTRUCTIONS from '../../../rctConstants';
import RCTFluencyPassageView from './RCTFluencyPassageView';
import { stopAudio } from '../../../../common/audio/audioActions';
import { playAvatarAudio } from '../../../../common/avatar/avatarActions';
import withAvatar from '../../../../common/avatar/withAvatar';
import AvatarView from '../../../../common/avatar/avatarView';
import {
    fetchRctFluCompContent, showSegment, saveFluencyResponse, saveFluencySegmentReadingTime,
    createFluencyComprehensionResults,
} from '../../../rctActions';
import { PASSAGE } from '../../../../constants/assessmentItemType';
import {
    enableDownButton, unmountScreen, blockScreen, unblockScreen, disableDownButton,
    openReadingReminderPopup, closeReadingReminderPopup,
} from '../../../../common/screen/screenActions';
import {
    showNextSegment, showNextSection, playReadyScript, onNextButtonClick,
    checkForDiscontinue, discontinueStudent,
    recreateFluencyComprehensionResults,
} from './RCTFluencyPassageActions';
import {
    selectPossibleResponse, resetQuestionsAndTimeTrackingState,
} from '../../../../common/questions/questionsActions';
import { getQuestionIndex } from '../../../../common/utils/urlParsers';
import { RCT, FLUENCY, COMPREHENSION } from '../../../../constants/measure';
import { startQuestionTimeTracking, stopQuestionTimeTracking, addToStartTime } from '../../../../common/timeTracking/timeTrackingActions';
import { QUESTION } from '../../../../common/timeTracking/timeTrackingKeys';

const FLUENCY_AUDIO = RCT_AUDIO_INSTRUCTIONS.FLUENCY;
const measure = RCT.toUpperCase();

const mapStateToProps = (state, ownProps) => {
    const activePassageIndex = getQuestionIndex(ownProps.match.params) - 1;
    const areResultsCreated = selectors.findResultFor(state, { measure, measureType: FLUENCY }) !== undefined
        && selectors.findResultFor(state, { measure, measureType: COMPREHENSION }) !== undefined;
    return {
        isScreenBlocked: selectors.getIsScreenBlocked(state),
        isGreyedOut: selectors.getIsScreenGreyedOut(state),
        isNextButtonActive: selectors.getIsNextButtonActive(state),
        isDownButtonEnabled: selectors.getIsDownButtonEnabled(state),
        isDataFetched: selectors.getIsRCTFluencyDataFetched(state),
        areResultsCreated,
        segments: selectors.getSegments(state, PASSAGE, activePassageIndex),
        question: selectors.getCurrentQuestion(state, PASSAGE, activePassageIndex),
        passageTitle: selectors.getPassageTitle(state, PASSAGE, activePassageIndex),
        passageLength: selectors.getPassagesCount(state, PASSAGE),
        activePassageIndex,
        activeSegmentIndex: selectors.getActiveSegmentIndex(state),
        isQuestionVisible: selectors.getIsQuestionVisible(state),
        isSegmentVisible: selectors.getIsSegmentVisible(state),
        selectedResponse: selectors.getSelectedIndex(state),
        studentGrade: selectors.getGrade(state),
        isReminderPopupActive: selectors.getIsReadingReminderPopupActive(state),
        isReadyScriptPlayed: selectors.getIsReadyScriptPlayed(state),
    };
};

const mapDispatchToProps = (dispatch) => ({
    fetchContent: () => {
        dispatch(fetchRctFluCompContent());
    },
    createResults: () => {
        dispatch(createFluencyComprehensionResults());
    },
    recreateFluencyComprehensionResults: () => {
        dispatch(recreateFluencyComprehensionResults());
    },
    readyScript: () => {
        dispatch(blockScreen());
        return dispatch(playReadyScript())
            .then(() => {
                dispatch(unblockScreen());
            });
    },
    onNext: (activePassageIndex) => {
        dispatch(onNextButtonClick(activePassageIndex));
    },
    initializePassage: () => {
        dispatch(showSegment(0));
        dispatch(enableDownButton());
    },
    onResponseSelected: (activePassageIndex, responseIndex) => {
        dispatch(blockScreen());
        if (responseIndex !== undefined) {
            dispatch(selectPossibleResponse(responseIndex));
        }
        return dispatch(saveFluencyResponse(activePassageIndex))
            .then(() => {
                dispatch(checkForDiscontinue(activePassageIndex));
            });
    },
    onPopupQuestionHide: (activePassageIndex) => {
        dispatch(resetQuestionsAndTimeTrackingState());
        dispatch(showNextSegment(activePassageIndex));
    },
    onSegmentShow: () => {
        dispatch(enableDownButton());
        dispatch(unblockScreen());
        dispatch(startQuestionTimeTracking());
    },
    onSegmentReadingComplete: (activePassageIndex) => {
        dispatch(stopQuestionTimeTracking());
        dispatch(blockScreen());
        dispatch(disableDownButton());
        return dispatch(saveFluencySegmentReadingTime(activePassageIndex))
            .then((passageHasQuestion) => {
                dispatch(showNextSection(passageHasQuestion, activePassageIndex));
            });
    },
    discontinueStudent: () => {
        dispatch(discontinueStudent());
    },
    showReadingReminder: () => {
        dispatch(blockScreen());
        dispatch(openReadingReminderPopup());
        dispatch(playAvatarAudio([FLUENCY_AUDIO.reminder]));
    },
    hideReadingReminder: (reminderOnDisplayTime) => {
        dispatch(closeReadingReminderPopup());
        dispatch(addToStartTime(QUESTION, reminderOnDisplayTime));
        dispatch(unblockScreen());
    },
    cleanup: () => {
        dispatch(stopAudio());
        dispatch(resetQuestionsAndTimeTrackingState());
        dispatch(unmountScreen());
    },
});

const avatarMapStateToProps = (state) => {
    const isReadyScriptPlayed = selectors.getIsReadyScriptPlayed(state);
    const instructions = isReadyScriptPlayed
        ? FLUENCY_AUDIO.passageInstruction : FLUENCY_AUDIO.ready;
    const position = isReadyScriptPlayed
        ? AvatarView.Position.LOWER_LEFT : AvatarView.Position.MIDDLE_LEFT;
    return {
        position,
        instructions,
    };
};

const RCTFluencyPassageContainer = compose(
    connect(mapStateToProps, mapDispatchToProps),
    withAvatar(avatarMapStateToProps),
)(RCTFluencyPassageView);

export default RCTFluencyPassageContainer;
